/**
 * Google Services Module
 * Wraps CCMS.Api.GoogleServices (the microservice that wraps Google Maps).
 */
export { GoogleServicesService, } from './GoogleServicesService';
import { GoogleServicesService } from './GoogleServicesService';
export function createGoogleServices(http, config) {
    return {
        google: new GoogleServicesService(http, config),
    };
}
//# sourceMappingURL=index.js.map